import { i18nTranslationHelper } from '@/i18n'
import { Grid } from '@mui/material'
import React, { useEffect, useImperativeHandle } from 'react'
import { SubmitErrorHandler, SubmitHandler, useForm } from 'react-hook-form'
import LanguageField from '../../input/language-field/language-field'

export type UserLanguageFormErrors = {
  language?: string | null
}

export type UserLanguageFormValues = {
  language: string
}

export type UserLanguageFormProps = {
  submitOnChange: boolean
  onSubmit: SubmitHandler<UserLanguageFormValues>
  onSubmitError?: SubmitErrorHandler<UserLanguageFormValues>
}

export type UserLanguageImperativeType = {
  submit: () => void
  reset: () => void
}

const UserLanguageForm = React.forwardRef(
  ({ submitOnChange, onSubmit, onSubmitError }: UserLanguageFormProps, ref) => {
    const defaultValues = {
      language: i18nTranslationHelper.getCurrentLanguage()
    }
    const {
      handleSubmit,
      control,
      reset,
      formState: { errors },
      watch
    } = useForm<UserLanguageFormValues>({
      defaultValues
    })

    const language = watch('language')

    useEffect(() => {
      if (submitOnChange && language !== i18nTranslationHelper.getCurrentLanguage()) {
        handleSubmit(onSubmit, onSubmitError)()
      }
    }, [language])

    useImperativeHandle(ref, () => ({
      reset: reset,
      submit: handleSubmit(onSubmit, onSubmitError),
      getErrors: () => errors
    }))

    return (
      <Grid container>
        <Grid item xs={submitOnChange ? 'auto' : 4}>
          <LanguageField name="language" control={control} required />
        </Grid>
      </Grid>
    )
  }
)

export default UserLanguageForm
